/**
 * Move React containers to different html placeholders without ever unmounting it.
 */

import angular from "angular"

const MoveReactComponentHereModule = angular.module(
  "classkickApp.moveReactComponentHere",
  [],
)

function MoveReactComponentHereDirective(
  $timeout: angular.ITimeoutService,
): angular.IDirective {
  let componentNode: HTMLElement | null = null
  let currentParent: angular.IAugmentedJQuery | null = null

  /**
   * Ensure React component is always rendered first
   */
  function getComponentNode(): HTMLElement | null {
    if (componentNode && !document.body.contains(componentNode)) {
      componentNode = null
      currentParent = null
    }

    if (!componentNode) {
      const sourceContainer = document.getElementById("react-component-source")
      if (sourceContainer && sourceContainer.firstElementChild) {
        componentNode = sourceContainer.firstElementChild as HTMLElement
      }
    }

    return componentNode
  }

  const directive: angular.IDirective = {
    restrict: "A",
    link: function (
      scope: angular.IScope,
      element: angular.IAugmentedJQuery,
      attrs: angular.IAttributes,
    ) {
      /**
       * Move component into html section based on screen size
       */
      function moveComponentHere(): void {
        const nodeToMove = getComponentNode()

        if (!nodeToMove) {
          return
        }

        if (currentParent && currentParent[0] === element[0]) {
          return
        }

        element.append(nodeToMove)
        currentParent = element
      }

      /**
       * Checks if this placeholder is rendered by the browser
       */
      function checkAndMove(): void {
        const isRendered = element[0].offsetParent !== null
        if (isRendered) {
          moveComponentHere()
        }
      }

      function handleVisibilityChange(shouldBeVisible: boolean): void {
        if (shouldBeVisible) {
          $timeout(checkAndMove, 0, false)
        }
      }

      /**
       * When screen is resized, check for placeholder
       */
      function handleResize(): void {
        if (scope.$eval(attrs.ngShow)) {
          checkAndMove()
        }
      }
      function cleanup(): void {
        window.removeEventListener("resize", handleResize)
      }

      scope.$watch(attrs.ngShow, handleVisibilityChange)
      window.addEventListener("resize", handleResize)
      scope.$on("$destroy", cleanup)
    },
  }

  return directive
}
MoveReactComponentHereDirective.$inject = ["$timeout"]

MoveReactComponentHereModule.directive(
  "moveReactComponentHere",
  MoveReactComponentHereDirective,
)

export const MoveReactComponentHereModuleName =
  MoveReactComponentHereModule.name
